import { Contact } from './types';

// Telescope keys the boot traits by display label, and their values are
// `unknown` on purpose (see Contact.traits). Reading the account name back is
// therefore a runtime check: anything that isn't a non-empty string counts as
// absent rather than rendering "[object Object]" next to the contact.
export const accountNameOf = (contact: Contact): string | null => {
  // Optional access on traits itself: this is the first consumer of the list
  // payload, and a row written before the identify fix can carry null here.
  const value = contact.traits?.['Account name'];
  return typeof value === 'string' && value.trim() !== '' ? value : null;
};
